module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body text-center"
  }, [_c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.viewInfo
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card-o"
  }), _vm._v(" High Mark\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.viewInfo
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  }), _vm._v(" Equifax\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.viewInfo
    }
  }, [_c('i', {
    staticClass: "fa fa-id-card-o"
  }), _vm._v(" Experian\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app box-widget box-red",
    on: {
      "click": _vm.viewInfo
    }
  }, [_c('i', {
    staticClass: "fa fa-id-card"
  }), _vm._v(" TransUnion\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header text-center"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" Cibil Details")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0407cd7b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Utilities/Cibil.vue
// module id = 718
// module chunks = 0